// extracted by mini-css-extract-plugin
module.exports =  {"Legend":"Legend__0Vi3O","tag":"tag__FKnfj","vertical":"vertical__u-9S2"};